class SearchFetcher
  constructor: ({@search_path, @facets_path, @user_searches_path, @logged_in, @search_context, @panels_path, @toggle_facet_state_path}) ->
    @searchXhr = null

  getSearch: ({query}) ->
    @searchXhr.abort() if @searchXhr
    @searchXhr = $.get(@search_path + '.json' + query)
    .fail (xhr) =>
      window.location.href = @search_path + query if xhr.status > 0

  createUserSearch: ({params}) ->
    if @logged_in is true and @user_searches_path? and @search_context? and params.keywords?.length
      searchParams = $.extend { keywords: params.keywords, params: params }, @search_context
      $.post @user_searches_path, search: searchParams

  getFacets: ({query, contexts, dontAbort}) ->
    @facetXhr.abort() if @facetXhr && !dontAbort
    @facetXhr = $.get @facets_path + '.json' + query, facets: contexts

  getPanels: (search_tab_id) ->
    @panelsXhr.abort() if @panelsXhr
    @panelsXhr = $.get(@panels_path, { search_tab_id: search_tab_id })

  toggleFacetstate: ({ keyForFacetState, keys }) ->
    $.post(@toggle_facet_state_path, { toggled_facet: keyForFacetState || keys })

LP.module('Searches').SearchFetcher = SearchFetcher
